import React from 'react';
import { ContentHeader } from 'C4';
import i18n from 'i18n-react';

const OffersView = () => {
  const offerButtons = [
    {
      title: 'Attraction Offers',
      link: 'https://travproconnect.com/profile/1162',
      img: 'https://tradecdn.imgix.net/1639599314-7405508a65668d18779a29a3daf2f6df.jpg?q=90&auto=format&w=800&h=auto',
    },
    {
      title: 'Hotel Offers',
      link: 'https://travproconnect.com/profile/1163',
      img: 'https://tradecdn.imgix.net/1639599727-60552630fe4c1e02243a42620761b12a.jpg?q=90&auto=format&w=800&h=auto',
    },
    {
      title: 'Shopping & Dining',
      link: 'https://travproconnect.com/profile/1164',
      img: 'https://tradecdn.imgix.net/1639600113-4d0399ad42a06da1eea23fe64be9a073.jpg?q=90&auto=format&w=800&h=auto',
    },
  ];

  return (
    <div className="offersView contentContainer">
      <div className="darken" />
      
      <ContentHeader
        header={i18n.translate('nav.offers')}
        line
      />
      <div className="offersView__content">
        {offerButtons && offerButtons.map((button, i) => {
          const key = i;

          if (button.title === 'Shopping & Dining') {
            return (
              <a
                className="offersView__content--button"
              >
                <div className="coming">Coming Soon</div>
                <img src={button.img} alt={button.title} />
                {button.title}
              </a>
            );
          }

          return (
            <a
              key={key}
              className="offersView__content--button"
              data-fancybox={button.title}
              data-type="iframe"
              href={button.link}
            > 
              <img src={button.img} alt={button.title} />
              {button.title}
            </a>
          );
        })}
      </div>
    </div>
  );
};

export default OffersView;
